
const settings = document.settings;

export default settings;
